/**
 * Accessibility fix (WCAG 2.1.1 / 4.1.2)
 *
 * usp-popup.liquid tags arbitrary merchant-authored elements (e.g. an
 * underlined "Sole Saver Pack" span inside a product metafield's rich
 * text -- see product-tabs.liquid's Fit notes accordion) with
 * data-product-popup once they appear in the DOM, via its own
 * MutationObservers, and wires a click handler that opens the matching
 * #<value> modal. Those elements are plain inline text with no href/
 * button semantics, so they were never reachable by keyboard at all --
 * clicking worked, Tab didn't land on them.
 *
 * This makes every non-native (not already <button>/<a>) element that
 * gains data-product-popup keyboard-operable: focusable, announced as a
 * button, and Enter/Space fires the same .click() a mouse click would,
 * reusing whatever click handling already exists rather than
 * duplicating the popup-open/close logic here. A MutationObserver is
 * used (rather than one-off setup) because these elements can appear
 * well after page load -- exactly the timing usp-popup.liquid itself
 * has to account for.
 *
 * The modal's own overlay backdrop is also tagged data-product-popup
 * (purely so clicking outside the modal closes it) but isn't a control
 * a keyboard user needs to tab to -- Escape/the close button already
 * cover that -- so it's explicitly excluded.
 */
(function () {
  'use strict';

  function isNativelyInteractive(el) {
    return el.tagName === 'BUTTON' || el.tagName === 'A';
  }

  function ensureAccessible(el) {
    if (!el || el.dataset.a11yPopupWired) return;
    if (el.classList.contains('product-modal__overlay')) return;

    el.dataset.a11yPopupWired = 'true';

    if (!isNativelyInteractive(el)) {
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');

      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.code !== 'Enter' && e.code !== 'Space') return;
        e.preventDefault();
        el.click();
      });
    }
  }

  function scan() {
    document.querySelectorAll('[data-product-popup]').forEach(ensureAccessible);
  }

  scan();

  var observer = new MutationObserver(scan);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-product-popup'],
    childList: true,
    subtree: true,
  });
})();
